import styled, { css } from 'styled-components';

import { ButtonIcon } from '@pkg/components/Sections/Profile/Buttons';

interface Props {
    $canShow?: boolean;
}

export const StyledYatButton = styled(ButtonIcon)<Props>`
    &&& {
        position: absolute;
        bottom: calc(100% + 10px);
        right: 0;
        opacity: 0;
        z-index: 1;
        transition: opacity ${({ theme }) => theme.transitions.speeds.normal}s;

        &:focus {
            opacity: 1;
        }

        ${({ $canShow }) =>
            !$canShow &&
            css`
                /* If can't show prevent hover / focus from showing element */
                opacity: 0 !important;
            `}
    }
`;
